@layer ui-kit;
@layer ui-kit {
  ._12smipy0 {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 16px;
    background-color: var(--_1iamlv41);
    box-shadow: inset 0 0 0 1px var(--_1iamlv4g);
    border-radius: 16px;
    color: var(--_1iamlv4a);
  }
  ._12smipy2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
  }
  ._12smipy3 {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  ._12smipy4 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
  }
  ._12smipy5 {
    height: 1px;
    width: 100%;
    background-color: var(--_1iamlv4g);
    border: 0;
    margin: 0;
  }
  ._12smipy6 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
  }
  ._12smipy7 {
    font-weight: 700;
    font-size: 16px;
    line-height: 1.3;
    letter-spacing: -0.02em;
    color: var(--_1iamlv4a);
    margin: 0;
  }
  ._12smipy8 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    color: var(--_1iamlv4d);
    margin: 0;
  }
  @media (hover: hover) and (pointer: fine) {
    ._12smipy1 {
      transition: box-shadow 150ms ease;
    }
    ._12smipy1:hover {
      box-shadow: inset 0 0 0 1px var(--_1iamlv4i);
    }
  }
}